import { HttpClient } from '@angular/common/http'
import { Environment } from '@fabrik/common'
import { Observable } from 'rxjs'

import { AIAgentProfile } from '../models/AIAgent'

export class AIAgentDataService {
    constructor(private environment: Environment, private http: HttpClient) {}

    agentProfiles(tenantId: string): Observable<AIAgentProfile[]> {
        return this.http.get<AIAgentProfile[]>(`${this.environment.fabrikAIHost}/api/${tenantId}/admin/agent-profiles`)
    }
}

